module.exports = __webpack_public_path__ + "static/logos-receitas-6860d664f05c0c300858229846efdf82.jpg";